import styled, { css } from 'styled-components';
import { Colors, hideScrollbar, mediaQueries } from '@fourthwall/components';
export const Container = styled.section `
  padding: 24px 20px;
  background: ${Colors.GS0};
  border: 1px solid ${Colors.GS400};
  border-style: solid none;
  border-radius: 2px;

  ${mediaQueries.tablet} {
    padding: 24px 28px;
    border-style: solid;
  }
`;
export const Header = styled.div `
  display: grid;
  gap: 20px;

  ${mediaQueries.tablet} {
    grid-template-columns: 1fr auto;
    gap: 24px;
    align-items: center;
  }
`;
export const ButtonGroup = styled.div `
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  gap: 8px;

  & > * {
    flex: 1;
  }

  ${mediaQueries.tablet} {
    gap: 12px;
    width: auto;
    flex-direction: row;

    & > * {
      flex: 0;
    }
  }
`;
export const EmptyState = styled.div `
  padding: 80px 40px;
  background: ${Colors.GS200};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
`;
export const Nav = styled.nav `
  display: none;

  ${mediaQueries.tablet} {
    display: block;

    &:has(button:disabled + button:disabled) {
      display: none;
    }
  }
`;
export const Slider = styled.div `
  --n: 2;
  --gap: 24px;

  display: grid;
  gap: var(--gap);
  grid-auto-flow: column;
  grid-auto-columns: calc((100% - (var(--n) - 1) * var(--gap)) / var(--n));

  overflow-x: auto;
  scroll-snap-type: x mandatory;
  ${hideScrollbar};

  ${mediaQueries.tablet} {
    --n: 4;
  }

  ${mediaQueries.laptop} {
    --n: 5;
  }
`;
export const SliderHeader = styled.div `
  margin-bottom: 12px;
  margin-top: 12px;

  ${mediaQueries.laptop} {
    margin-bottom: 16px;
    margin-top: 16px;
  }

  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const Slide = styled.a `
  display: block;

  scroll-snap-align: start end;
`;
export const Footer = styled.footer `
  margin-top: 24px;

  text-align: center;

  ${mediaQueries.laptop} {
    margin-top: 16px;
  }
`;
export const PillContainer = styled.div `
  display: flex;
  gap: 8px;
`;
export const PillItem = styled.button `
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  outline: none;
  padding: 5px 12px;

  color: ${Colors.GS1000};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;

  ${(props) => css `
    background: ${props.active ? Colors.GS300 : 'transparent'};
  `};

  &:hover {
    background: ${Colors.GS400};
  }
`;
